import React from 'react';

import './styles/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from 'pages/Home';
import LayoutAuthenticated from './layouts/Authenticated';
import { RecoilRoot } from 'recoil';
import { message } from 'antd';
import LoginPage from './pages/LoginPage';
import Unauthenticated from './layouts/Unauthenticated';
import { AppRoutes } from './configs/AppRoutes';
import ContactPage from './pages/ContactPage';
import { AuthProvider } from 'features/auth/contexts';
import ListAiHubAccountsPage from 'pages/accounts/list_hub';
import ListAiStoreAccountsPage from 'pages/accounts/list_store';
import ListAiResellerAccountsPage from 'pages/accounts/list_reseller';
import NewAccountPage from 'pages/accounts/new';
import ListAppsPage from 'pages/apps/list';
import ListOrderPaymentsPage from 'pages/orderPayments/list';
import ListOrderPaymentsPartnerPage from 'pages/orderPayments/list_partner';
import ListRecommendedAppsPage from 'pages/recommendedApps/list';
import ListSubscriptionPage from 'pages/subscriptions/list';
import ListTenantsPage from 'pages/tenants/list';
import ListCustomDomainsPage from 'pages/custom_domains/list';
import DetailCustomDomainsPage from 'pages/custom_domains/detail';
import ListCreditsPage from 'pages/credits/list';
import ListPromoCodesPage from 'pages/promo_codes/list';
import NewPromoCodesPage from 'pages/promo_codes/new';
import DetailPromoCodesPage from 'pages/promo_codes/detail';
import ListManagersPage from 'pages/managers/list';
import NewManagerPage from 'pages/managers/new';
import DetailManagerPage from 'pages/managers/detail';
import ListCommissionAffiliatesPage from 'pages/affiliates/list_commission';
import ListWithDrawAffiliatesPage from 'pages/affiliates/list_withdraw';
import WithdrawDetailAffiliatePage from 'pages/affiliates/withdraw_detail'
import ListCommissionStoreAffiliatesPage from 'pages/affiliates/list_commission_store';
import ListWithdrawStoreAffiliatesPage from 'pages/affiliates/list_withdraw_store';
import AccountStatisticsPage from 'pages/statistics/account'
import OrderPaymentStatisticsPage from 'pages/statistics/order_payment'
import MessageStatisticsPage from 'pages/statistics/message'
import TenantDetailsStatisticsPage from 'pages/statistics/tenant_detail'
import ListMonthlyCreditsPage from 'pages/monthly_credits/list';  

function App() {
  message.config({
    duration: 2
  });
  return (
    <RecoilRoot>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<LayoutAuthenticated />}>
              <Route path="/" element={<Home />} />
              {/* Statistics */}
              <Route path={AppRoutes.Statistics.Accounts.path} element={<AccountStatisticsPage />} />
              <Route path={AppRoutes.Statistics.OrderPayments.path} element={<OrderPaymentStatisticsPage />} />
              <Route path={AppRoutes.Statistics.Messages.path} element={<MessageStatisticsPage />} />
              <Route path={AppRoutes.Statistics.TenantDetails.path} element={<TenantDetailsStatisticsPage />} />
              {/* Accounts */}
              <Route path={AppRoutes.Accounts.ListAiHub.path} element={<ListAiHubAccountsPage />} />
              <Route path={AppRoutes.Accounts.ListAiStore.path} element={<ListAiStoreAccountsPage />} />
              <Route path={AppRoutes.Accounts.ListAiReseller.path} element={<ListAiResellerAccountsPage />} />
              <Route path={AppRoutes.Accounts.New.path} element={<NewAccountPage />} />

              <Route path={AppRoutes.Apps.List.path} element={<ListAppsPage />} />

              <Route path={AppRoutes.OrderPayments.List.path} element={<ListOrderPaymentsPage />} />
              <Route path={AppRoutes.OrderPayments.ListPartner.path} element={<ListOrderPaymentsPartnerPage />} />

              <Route path={AppRoutes.RecommendApps.List.path} element={<ListRecommendedAppsPage />} />

              <Route path={AppRoutes.Subscriptions.List.path} element={<ListSubscriptionPage />} />

              <Route path={AppRoutes.Tenants.List.path} element={<ListTenantsPage />} />

              <Route path={AppRoutes.CustomDomains.List.path} element={<ListCustomDomainsPage />} />

              <Route path={AppRoutes.CustomDomains.Detail.path} element={<DetailCustomDomainsPage />} />

              <Route path={AppRoutes.Credits.List.path} element={<ListCreditsPage />} />

              <Route path={AppRoutes.MonthlyCredits.List.path} element={<ListMonthlyCreditsPage />} />

              <Route path={AppRoutes.PromoCodes.List.path} element={<ListPromoCodesPage />} />
              <Route path={AppRoutes.PromoCodes.New.path} element={<NewPromoCodesPage />} />
              <Route path={AppRoutes.PromoCodes.Detail.path} element={<DetailPromoCodesPage />} />

              <Route path={AppRoutes.Managers.List.path} element={<ListManagersPage />} />
              <Route path={AppRoutes.Managers.New.path} element={<NewManagerPage />} />
              <Route path={AppRoutes.Managers.Detail.path} element={<DetailManagerPage />} />

              <Route path={AppRoutes.Affiliates.CommissionList.path} element={<ListCommissionAffiliatesPage />} />
              <Route path={AppRoutes.Affiliates.WithdrawList.path} element={<ListWithDrawAffiliatesPage />} />
              <Route path={AppRoutes.Affiliates.WithdrawDetail.path} element={<WithdrawDetailAffiliatePage />} />
              <Route path={AppRoutes.Affiliates.CommissionStoreList.path} element={<ListCommissionStoreAffiliatesPage />} />
              <Route path={AppRoutes.Affiliates.WithdrawStoreList.path} element={<ListWithdrawStoreAffiliatesPage />} />

            </Route>

            <Route element={<Unauthenticated />}>
              <Route path={AppRoutes.Login.path} element={<LoginPage />} />
              <Route path={AppRoutes.Contact.path} element={<ContactPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default App;
